module.exports = ".spacediv{\n    margin-top: 4px;\n}\n\n.inputSpace{\n    margin-left: 20px !important;\n}\n\n.text-nowrap {\n    white-space: nowrap !important;\n    display: inline-block !important; \n  \n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-section/bad-questionnaire-section.component.css
// module id = ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-section/bad-questionnaire-section.component.css
// module chunks = main